import { useEffect } from "react";
import FeatherIcon from "feather-icons-react";

import ManIcon from "../../Assets/Images/html5-templates/man.png";
import Carousel from "react-bootstrap/Carousel";

const EcommerceCarouselPreview = (props: any) => {
  const {
    title_font_color,
    subtitle_font_color,
    close_btn_bg_color,
    close_btn_fg_color,
    cta_btn_bg_color,
    cta_btn_font_color,
    title_text,
    sub_title_text,
    cta_btn_text,
    link_url,
    carousel_bg_color,
    carousel_fg_color,
    bgImageLink,
    logoImageLink,
    productItemImageLinks,
    ctaBtnIcnLink,
    product_desc_bg_color,
    product_desc_font_color,
  } = props.templateProperties;

  useEffect(() => {
    let prevEl: any = document.querySelector(".carousel-control-prev");
    let nextEl: any = document.querySelector(".carousel-control-next");
    if (prevEl) {
      prevEl.style.background = carousel_bg_color;
    }
    if (nextEl) {
      nextEl.style.background = carousel_bg_color;
    }
  }, [carousel_bg_color, carousel_fg_color]);

  return (
    <>
      <div
        className="bannerGenerat"
        style={
          bgImageLink
            ? { backgroundImage: `url(${bgImageLink})` }
            : { backgroundColor: "#a6a6a6" }
        }
      >
        <a
          href={link_url ? link_url : ""}
          target="_blank"
          rel="noreferrer"
          className="overlayLink"
        >
          &nbsp;
        </a>
        <span
          className="closeBtn"
          style={{
            backgroundColor: close_btn_bg_color
              ? close_btn_bg_color
              : "#a5c7db",
            color: close_btn_fg_color ? close_btn_fg_color : "#fff",
          }}
        >
          +
        </span>
        <div
          className="logo"
          style={
            logoImageLink
              ? {
                  backgroundImage: `url(${logoImageLink})`,
                  padding: "5px 10px",
                }
              : {
                  backgroundColor: "#a5c7db",
                  color: "#000",
                  padding: "5px 10px",
                }
          }
        >
          {logoImageLink ? "" : "LOGO"}
        </div>
        <h2
          style={{
            color: title_font_color,
            fontSize: "22px",
          }}
        >
          {title_text ? title_text : "Title XXX"}
        </h2>
        <p
          style={{
            color: subtitle_font_color,
            fontSize: "18px",
            fontWeight: "500",
          }}
        >
          {sub_title_text ? sub_title_text : "subtitle XXX XXX"}
        </p>

        <div className="imgbox">
          <div className="imgslider">
            <Carousel id="carosouleID">
              {productItemImageLinks && productItemImageLinks.length > 0 ? (
                productItemImageLinks.map((x: any, index: any) => {
                  return (
                    <Carousel.Item key={`product_item_${index}`}>
                      <a
                        href={x.product_url ? x.product_url : "#"}
                        target="_blank"
                        rel="noreferrer"
                        className="overlayLink"
                      >
                        <img
                          src={x.product_image}
                          alt="img"
                          className="mainImg"
                        />
                        <div
                          className="productDescriptor"
                          style={{
                            backgroundColor: product_desc_bg_color
                              ? product_desc_bg_color
                              : "#a5c7db",
                            color: product_desc_font_color
                              ? product_desc_font_color
                              : "#000",
                            padding: "10px 7px",
                          }}
                        >
                          <strong>{x.product_descriptor}</strong>
                          <div
                            className="ctacart"
                            style={{
                              backgroundColor: cta_btn_bg_color
                                ? cta_btn_bg_color
                                : "#fff",
                              //textTransform: "uppercase",
                              fontSize: "16px",
                              color: cta_btn_font_color
                                ? cta_btn_font_color
                                : "#000",
                            }}
                          >
                            <span
                              className="icon"
                              style={{
                                color: cta_btn_font_color
                                  ? cta_btn_font_color
                                  : "#000",
                                border: `1px solid ${
                                  cta_btn_font_color
                                    ? cta_btn_font_color
                                    : "#000"
                                }`,
                              }}
                            >
                              {ctaBtnIcnLink ? (
                                <img
                                  src={ctaBtnIcnLink}
                                  alt=""
                                  width={15}
                                  height={15}
                                />
                              ) : (
                                <FeatherIcon icon="shopping-cart" />
                              )}
                            </span>
                            {cta_btn_text ? cta_btn_text : "CTA"}
                          </div>
                        </div>
                      </a>
                    </Carousel.Item>
                  );
                })
              ) : (
                <Carousel.Item key={`product_item_1`}>
                  <img src={ManIcon} alt="img" className="mainImg" />

                  <div
                    className="productDescriptor"
                    style={{
                      backgroundColor: product_desc_bg_color
                        ? product_desc_bg_color
                        : "#a5c7db",
                      color: product_desc_font_color
                        ? product_desc_font_color
                        : "#000",
                      padding: "10px 7px",
                    }}
                  >
                    <strong>Product Description</strong>
                    <div
                      className="ctacart"
                      style={{
                        backgroundColor: cta_btn_bg_color
                          ? cta_btn_bg_color
                          : "#fff",
                        //textTransform: "uppercase",
                        fontSize: "16px",
                        color: cta_btn_font_color ? cta_btn_font_color : "#000",
                      }}
                    >
                      <span
                        className="icon"
                        style={{
                          color: cta_btn_font_color
                            ? cta_btn_font_color
                            : "#000",
                          border: `1px solid ${
                            cta_btn_font_color ? cta_btn_font_color : "#000"
                          }`,
                        }}
                      >
                        {ctaBtnIcnLink ? (
                          <img
                            src={ctaBtnIcnLink}
                            alt=""
                            width={15}
                            height={15}
                          />
                        ) : (
                          <FeatherIcon icon="shopping-cart" />
                        )}
                      </span>
                      {cta_btn_text ? cta_btn_text : "CTA"}
                    </div>
                  </div>
                </Carousel.Item>
              )}
            </Carousel>
          </div>
        </div>
      </div>
    </>
  );
};

export default EcommerceCarouselPreview;
